import { useCallback, useState } from 'react'

const useMultiToggle = (
  initialOn: string[] = []
): [
  (id: string) => boolean,  // isOn
  (id: string) => void,     // toggle
  () => string[],           // getOn
  (ids: string[]) => void,  // setOn
  () => void                // reset
] => {
  const [selected, setSelected] = useState<{ [key: string]: boolean }>(onObj(initialOn))
  const isOn = useCallback((id: string) => !!selected[id], [selected])
  const toggle = useCallback((id: string) => setSelected({ ...selected, [id]: !selected[id] }), [
    selected,
    setSelected
  ])
  const getOn = useCallback(
    () =>
      Object.entries(selected)
        .filter(([_, on]) => on)
        .map(([id]) => id),
    [selected]
  )
  const setOn = useCallback((ids: string[]) => setSelected(onObj(ids)), [setSelected])
  const reset = useCallback(() => setSelected({}), [setSelected])
  return [isOn, toggle, getOn, setOn, reset]
}

const onObj = (ids: string[]) => {
  const onIds = {}
  ids.forEach(i => (onIds[i] = true))
  return onIds
}

export default useMultiToggle
